import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
type VerticalAlignOption = 'middle' | 'baseline' | 'bottom';

@Component({
  selector: 'app-special-requirements-warning',
  standalone: true,
  imports: [MatIconModule, MatTooltipModule],
  templateUrl: './special-requirements-warning.component.html',
  styleUrl: './special-requirements-warning.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpecialRequirementsWarningComponent {
  tooltipText = input<string | null>(null);
  label = input<string>('Special Requirements');
  showLabel = input<boolean>(false);
  verticalAlign = input<VerticalAlignOption>('middle');
}
